import React from "react";
import { clsx } from "clsx";

function ButtonLong({
  type,
  children,
  onClick,
  secondary,
  className,
  disabled,
  loading,
}) {
  return (
    <button
      onClick={(e) => {
        if (disabled || loading) return;
        if (type !== "submit") {
          e.preventDefault();
        }
        onClick && onClick(e);
      }}
      type={type || "submit"}
      disabled={disabled || loading}
      className={clsx(
        "group relative flex w-full items-center justify-center gap-2 rounded-xl px-6 py-3.5 text-sm font-black tracking-wide leading-6 text-white transition-all duration-300 shadow-xl overflow-hidden active:scale-[0.98]",
        "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-500",
        secondary
          ? "bg-slate-800 hover:bg-slate-700 shadow-slate-900/10 hover:shadow-slate-900/20"
          : "bg-primary-600 hover:bg-primary-500 shadow-primary-500/20 hover:shadow-primary-500/30",
        disabled || loading
          ? "opacity-50 grayscale cursor-not-allowed shadow-none hover:shadow-none active:scale-100"
          : "",
        className,
      )}
    >
      {/* Glossy overlay effect on hover */}
      <div className="absolute inset-0 translate-x-[-100%] group-hover:translate-x-[100%] bg-gradient-to-r from-transparent via-white/10 to-transparent transition-transform duration-1000 ease-in-out pointer-events-none" />

      {loading && (
        <svg
          className="animate-spin h-5 w-5 text-white me-2"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          ></circle>
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          ></path>
        </svg>
      )}

      <span className="relative z-10 flex items-center gap-2">{children}</span>
    </button>
  );
}

export default ButtonLong;
